import { Link } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";
import { PrivacyContent } from "../components/legal/PrivacyContent";

/**
 * 隱私權政策頁面
 * 顯示 Mayi AI 的隱私權政策內容
 */
export function PrivacyPage() {
  const logo = "/assets/images/logo.jpg";

  return (
    <div className="min-h-screen bg-[#FDF8F0] relative overflow-hidden font-sans">
      {/* 浮動裝飾元素 */}
      <div className="absolute w-72 h-72 bg-[#6B8E5A] bg-opacity-10 rounded-full -top-36 -right-36 animate-float hidden sm:block"></div>
      <div
        className="absolute w-48 h-48 bg-[#A0956B] bg-opacity-10 rounded-full -bottom-24 -left-24 animate-float hidden sm:block"
        style={{ animationDelay: "2s" }}
      ></div>

      {/* 主要內容 */}
      <div className="min-h-screen flex items-center justify-center px-4 py-12 sm:py-16 relative z-10">
        <div className="w-full max-w-6xl">
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 relative overflow-hidden mx-auto animate-fade-in">
            {/* 頂部漸變邊框 */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#6B8E5A] to-[#A0956B]"></div>

            {/* 裝飾背景 */}
            <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-gradient-to-br from-[#6B8E5A]/5 to-[#A0956B]/5 rounded-full pointer-events-none"></div>

            {/* 標題區 */}
            <div className="text-center mb-8 relative">
              <img
                src={logo}
                alt="Logo"
                className="w-20 h-20 mx-auto mb-6 shadow-md rounded"
              />
              <h1 className="text-3xl font-bold text-[#6B8E5A] mb-2 font-serif">
                隱私權政策
              </h1>
              {/* <p className="text-[#A0956B] text-lg">最後更新：2025年05月01日</p> */}
            </div>

            {/* 隱私權政策內容 */}
            <div className="max-h-[60vh] overflow-y-auto pr-4 -mr-4 custom-scrollbar">
              <PrivacyContent />
            </div>

            {/* 頁尾 */}
            <div className="mt-8 pt-6 border-t border-[#F5F1E8] text-center">
              <Link
                to={ROUTES.LOGIN}
                className="inline-flex items-center gap-2 text-[#6B8E5A] hover:text-[#9BBF85] transition-all duration-300 font-medium text-sm group"
              >
                <svg
                  className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
                返回登入頁面
              </Link>
            </div>
          </div>

          {/* 底部引用 */}
          <div className="mt-8 text-center text-[#A0956B] text-sm">
            <p className="mb-2 font-serif">
              "如同台中人熬的麻薏湯，用心保護您的隱私"
            </p>
            <p>— 麻薏 AI 團隊</p>
          </div>
        </div>
      </div>
    </div>
  );
}
